import { Text, TextProps } from '@chakra-ui/react'

const StatText = (props: TextProps) => (
  <Text
    {...props}
    sx={{
      fontVariant: 'tabular-nums',
      ...props.sx,
    }}
  />
)

export default StatText
